// extracted by mini-css-extract-plugin
export default {"tabs":"DomainOverviewPage_tabs__a7AvQ"};